import useMediaQuery from "@mui/material/useMediaQuery";

export function useReducedMotionPreference(): boolean {
    return useMediaQuery("(prefers-reduced-motion: reduce)");
}
